const typesNames = {
  [`white-box`]: {
    ru: `White box`,
    en: `White box`,
    cn: `White-box风格的公寓`
  },
  [`istoricheskie-kvartiry`]: {
    ru: `Резиденция`,
    en: `Residence`,
    cn: `住所`
  },
  [`loft`]: {
    ru: `Loft-квартира`,
    en: `Loft`,
    cn: `LOFT风格的公寓`
  },
  [`commercial`]: {
    ru: `Коммерческое помещение`,
    en: `Commercial properties`,
    cn: `商业空间`
  },
  [`unfinished`]: {
    ru: `Квартира без отделки`,
    en: `Apartments in shell form`,
    cn: `毛坯房`
  }
};
const statusText = {
  [`on_sale`]: {
    ru: `В продаже`,
    en: `For sale`,
    cn: `正在出售中`
  }
};

const texts = {
  flat: {
    ru: `кв`,
    en: `apt`,
    cn: `公寓`
  },
  flat_full: {
    ru: `квартира`,
    en: `apartment`,
    cn: `公寓`
  },
  plan: {
    ru: `Планировка`,
    en: `Floor plan`,
    cn: `房型安排`
  },
  presentation: {
    ru: `Презентация`,
    en: `Presentation`,
    cn: `推介会`
  },
  floor: {
    ru: `Этаж`,
    en: `Floor`,
    cn: `楼层`
  },
  dorms: {
    ru: `Спальни`,
    en: `Bedrooms`,
    cn: `卧室的数量`
  },
  found: {
    ru: `Найдено квартир`,
    en: `Properties found`,
    cn: `为您找到相关的公寓`
  },
  sort: {
    ru: `Сортировать по`,
    en: `Sort by`,
    cn: `根据`
  },
  sort_by_square: {
    ru: `площади`,
    en: `square`,
    cn: `面积`
  },
  sort_by_floors: {
    ru: `кол-ву этажей`,
    en: `number of floors`,
    cn: `层数`
  },
  sort_by_dorms: {
    ru: `кол-ву спален`,
    en: `number of bedrooms`,
    cn: `卧室的数量 分类`
  },
  type: {
    ru: `Тип`,
    en: `Type`,
    cn: `类型`
  },
  square_full: {
    ru: `Площадь`,
    en: `Area`,
    cn: `面积`
  },
  floors_num: {
    ru: `Кол-во этажей`,
    en: `Number of floors`,
    cn: `层数`
  },
  dorms_num: {
    ru: `Кол-во спален`,
    en: `Number of bedrooms`,
    cn: `卧室的数量 分类`
  },
  link_3d: {
    ru: `3D Тур по квартире`,
    en: `3D Tour of an Apartment`,
    cn: `公寓3D旅游`,
  },
  link_panorama: {
    ru: `Панорамный вид из квартиры`,
    en: `Panoramic view from an Apartment`,
    cn: `窗外的景色`,
  },
  video: {
    ru: `Презентация квартиры`,
    en: `Presentation`,
    cn: `演示文稿`
  }
};

export const renderResultList = (flats = [], locale) => {
  const renderFlat = (flat) => {
    const {
      apt_number: number,
      link_to_3d,
      link_to_panorama,
      video,
      bedrooms,
      floor,
      sale_status: status,
      square,
      flat_type: type,
      slug
    } = flat;
    const getFloorValue = () => {
      let str = ``;

      floor.sort((a, b) => {
        return a[0] > b[0] ? 1 : -1;
      });

      floor.forEach((item, index) => {
        const floorValue = index > 0 ? `-` + item[0] : item[0];

        if (!floorValue) {
          str = `-`;

          return str;
        };

        str += floorValue;
      });

      return str;
    };
    const isPlanExist = floor.some(item => {
      return item[1];
    });

    const planLink =
      `<div class="flat-card__plan link ${isPlanExist ? `flat-card__plan--full` : ``}">
        ${texts[`plan`][locale]}
      </div>`;

    const presentationLink =
      `<a class="link ${isPlanExist ? `flat-card__plan--full` : ``}" href="/presentations/flat-19.pdf" target="_blank">
        ${texts[`presentation`][locale]}
      </a>`;

    const dddLink = link_to_3d ?
      `<button data-link3d="${link_to_3d}" class="flat-card__3d-link link js-modal-3d">
        ${texts[`link_3d`][locale]}
      </button>` : '';

    const panoramaLink = link_to_panorama ?
      `<button data-panorama-img="${link_to_panorama}" class="flat-card__panorama-link link js-modal-panorama">
        ${texts[`link_panorama`][locale]}
      </button>` : '';

    const videoLink = video ?
      `<button data-video="${video}" class="link js-modal-video">
          ${texts['video'][locale]}
      </button>` : '';

    return `<li class="flatography-result__item flat-card">
              <div class="flat-card__link js-gallery-plans" data-number="${number}" data-href="/${locale}/flats/${slug}">
                <div class="flat-card__inner flat-card__link js-gallery-plans">
                  <div class="flat-card__column">
                    <div class="flat-card__number">${texts[`flat`][locale]}. <span>${number}</span></div>
                    <div class="flat-card__type flat-card__type--desktop">${typesNames[type] ? typesNames[type][locale] : ``}</div>
                  </div>
                  <div class="flat-card__column">
                    <div class="flat-card__type flat-card__type--mobile">${typesNames[type] ? typesNames[type][locale] : ``}</div>
                    <div class="flat-card__text flat-card__floor">${texts[`floor`][locale]} ${getFloorValue()}</div>
                    <div class="flat-card__text flat-card__dorms">${texts[`dorms`][locale]}: ${bedrooms || 0}</div>
                      <div class="flat-card__text flat-card__status">${status ? statusText[status][locale] : ``}</div>
                  </div>
                  <div class="flat-card__column">
                    <div class="flat-card__square"><span>${square || 0}</span> m<sup>2</sup></div>
                  </div>
                </div>
                <div class="flat-card__links-cont">
                  ${planLink}
                  ${number === "19" ? presentationLink : ""}
                  ${dddLink}
                  ${panoramaLink}
                  ${videoLink}
                </div>
              </div>
             </li>`;
  };

  return flats.map(renderFlat).join(``);
};

export const renderOptions = (num = 0, locale) => {
  return `<div class="flatography-result__option">${texts[`found`][locale]}: ${num}</div>
          <div class="flatography-result__option flatography-result__option--square sort-panel">${texts[`sort`][locale]}
            <div class="sort-panel__wrap">
              <span class="sort-panel__item sort-panel__item--visible" data-sort="square">${texts[`sort_by_square`][locale]}</span>
              <span class="sort-panel__item" data-sort="floor">${texts[`sort_by_floors`][locale]}</span>
              <span class="sort-panel__item" data-sort="bedrooms">${texts[`sort_by_dorms`][locale]}</span>
            <div>
          </div>`
};

export const renderVisualDescriptions = (flats = [], activeNum, locale) => {
  const renderDescription = (flat) => {
    const {
      apt_number: number,
      bedrooms,
      floor,
      sale_status:
        status,
      square,
      type
    } = flat;
    const isActiveFlat = number === activeNum;
    const renderType = () => {
      return `<div class="labeled-text labeled-text--padding-60">
                  <div class="labeled-text__title">${texts[`type`][locale]}</div>
                  <div class="labeled-text__text">${typesNames[type][locale]}</div>
                </div>`;
    };

    return `<div class="flatography-visual__description ${isActiveFlat ? `flatography-visual__description--shown` : ``}" data-flat="${number}">
              <div class="flatography-visual__row">
                <div class="labeled-text">
                  <div class="labeled-text__title">${texts[`flat_full`][locale]}</div>
                  <div class="labeled-text__text labeled-text__text--futura labeled-text__text--huge">№ ${number}</div>
                </div>
                <div class="flatography-visual__status">${status ? statusText[status][locale] : ``}</div>
              </div>
              <div class="flatography-visual__row">
                ${type ? renderType() : ``}
                <div class="labeled-text labeled-text--padding-60">
                  <div class="labeled-text__title">${texts[`square_full`][locale]}</div>
                  <div class="labeled-text__text">${+square} m<sup>2</sup></div>
                </div>
                <div class="labeled-text labeled-text--padding-60">
                  <div class="labeled-text__title labeled-text__title--nowrap">${texts[`floors_num`][locale]}</div>
                  <div class="labeled-text__text">${+floor.length}</div>
                </div>
                <div class="labeled-text labeled-text--padding-60">
                  <div class="labeled-text__title labeled-text__title--nowrap">${texts[`dorms_num`][locale]}</div>
                  <div class="labeled-text__text">${+bedrooms}</div>
                </div>
              </div>
            </div>`;
    };

  return flats.map(renderDescription).join(``);
};
